export const ACCOUNTACTIVE = 'accountActive';
export const PERSONAS = 'personas';
export const INTERESTS = 'interests';
export const CHALLENGES = 'challenges';
export const SOLUTIONS = 'solutions';
export const DISCUSSIONS = 'discussions';
export const COMMENTS = 'comments';